// extracted by mini-css-extract-plugin
export default {"Empty":"styles_Empty__7Q-5X","Icon":"styles_Icon__Izp02","Title":"styles_Title__1+9sy"};